<lib-form-field-container
    [isOptional]="false"
    [hideErrors]="true"
    [kind]="FormContainerKind.None">
    <ng-content
        supportingText
        select="[supportingText]"></ng-content>

    <ng-container readOnly>
        <div
            #providedReadOnly
            class="wrapper-content">
            <ng-content select="[readOnly]"></ng-content>
        </div>
        <div class="default-content">{{ formControl.value }}</div>
    </ng-container>

    <div class="typography-title-small">
        <ng-container *ngTemplateOutlet="myLabel"></ng-container>
    </div>
    <form
        [formGroup]="form"
        class="padding-y-16">
        @if (!alwaysRepeat) {
            <lib-radio-group
                (change)="TogglePicker($event)"
                [formControl]="form.controls.UseRecurrence"
                [orientation]="Orientation.Vertical">
                <lib-radio-group-item
                    qaTag="recurrence-picker-once-option-radio"
                    [value]="RecurrenceType.Once">
                    <ng-content select="[onceOptionText]"></ng-content>
                    <ng-content
                        radioSupportingText
                        select="[onceOptionSupportingText]"></ng-content>
                </lib-radio-group-item>
                @if (hasHoldOption) {
                    <lib-radio-group-item
                        qaTag="recurrence-picker-hold-weekly-option-radio"
                        [value]="RecurrenceType.HoldWeekly">
                        <ng-content select="[holdOptionText]"></ng-content>
                        <ng-content
                            radioSupportingText
                            select="[holdOptionSupportingText]"></ng-content>
                    </lib-radio-group-item>
                }
                <lib-radio-group-item
                    qaTag="recurrence-picker-recurring-option-radio"
                    [value]="RecurrenceType.Recurring">
                    <ng-content select="[recurrenceOptionText]"></ng-content>
                    <ng-content
                        radioSupportingText
                        select="[recurrenceOptionSupportingText]"></ng-content>
                </lib-radio-group-item>
            </lib-radio-group>
        }

        @if (form.controls.UseRecurrence.value == RecurrenceType.Recurring) {
            <lib-input-select
                (change)="FrequencyChanged()"
                [qaTag]="qaTag ? qaTag + '-frequency-input-select' : ''"
                [formControl]="form.controls.Frequency"
                [layout]="FormFieldLayout.Half"
                [sortBy]="keepOrder">
                <ng-container
                    label
                    i18n="@@LibraryFormFieldFrequencyPickerFrequencyLabel">
                    Frequency
                </ng-container>

                @if (!hideDaily) {
                    <lib-input-select-item
                        qaTag="recurrence-picker-frequency-daily-option-select-item"
                        [value]="RepeatFrequencyEnum.Daily"
                        i18n="@@CommonDaily">
                        Daily
                    </lib-input-select-item>
                }
                <lib-input-select-item
                    qaTag="recurrence-picker-frequency-weekly-option-select-item"
                    [value]="RepeatFrequencyEnum.Weekly"
                    i18n="@@CommonWeekly">
                    Weekly
                </lib-input-select-item>
                <lib-input-select-item
                    qaTag="recurrence-picker-frequency-monthly-option-select-item"
                    [value]="RepeatFrequencyEnum.Monthly"
                    i18n="@@CommonMonthly">
                    Monthly
                </lib-input-select-item>
                <lib-input-select-item
                    qaTag="recurrence-picker-frequency-yearly-option-select-item"
                    [value]="RepeatFrequencyEnum.Yearly"
                    i18n="@@CommonYearly">
                    Yearly
                </lib-input-select-item>
            </lib-input-select>
            @if (form.controls.Frequency.value != RepeatFrequencyEnum.Daily) {
                <lib-input-number
                    [formControl]="form.controls.Interval"
                    [layout]="FormFieldLayout.Half"
                    [qaTag]="qaTag ? qaTag + '-repeats-every-input' : ''"
                    [errorMessages]="intervalErrors"
                    (change)="Changed()">
                    <ng-container
                        label
                        i18n="@@LibraryFormFieldFrequencyPickerRepeatsEveryLabel">
                        Repeats Every
                    </ng-container>
                    <ng-container suffixText>
                        {{ intervalSuffixText }}
                    </ng-container>
                </lib-input-number>
            }

            @if (form.controls.Frequency.value == RepeatFrequencyEnum.Daily) {
                <lib-pill-select-group
                    [formControl]="form.controls.DaySelection"
                    [errorMessages]="daysOfWeekErrors"
                    (change)="Changed()">
                    <ng-container
                        label
                        i18n="@@LibraryFormFieldFrequencyPickerMonthlyRepeatOnLabel">
                        Repeat On
                    </ng-container>

                    @for (day of localizedAbbrDays; track day) {
                        <lib-pill-select-group-item
                            [isCircle]="isMobile"
                            [value]="dayOfWeekEnums[$index]"
                            [qaTag]="qaTag ? qaTag + '-' + day + '-pill-select' : ''">
                            {{ day }}
                        </lib-pill-select-group-item>
                    }
                </lib-pill-select-group>
            }

            @if (form.controls.Frequency.value == RepeatFrequencyEnum.Monthly) {
                <lib-radio-group
                    [formControl]="form.controls.RepeatMonthType"
                    [orientation]="Orientation.Vertical"
                    (change)="Changed()">
                    <ng-container
                        label
                        i18n="@@LibraryFormFieldFrequencyRepeatLabel">
                        Repeat
                    </ng-container>
                    <lib-radio-group-item
                        [value]="RepeatMonthTypeEnum.Absolute"
                        i18n="@@LibraryFormFieldFrequencyPickerMonthlyOnDayAbsolute"
                        [qaTag]="qaTag ? qaTag + '-repeat-monthly-on-nth-day' : ''">
                        Monthly on day {{ dayOfMonth }}
                    </lib-radio-group-item>
                    <lib-radio-group-item
                        [value]="RepeatMonthTypeEnum.Relative"
                        [qaTag]="qaTag ? qaTag + '-repeat-monthly-on-ith-day-of-jth-week' : ''">
                        <ng-container>{{ dayOfWeek | formatMonthlyToWords: weekOfMonth }}</ng-container>
                    </lib-radio-group-item>
                </lib-radio-group>
            }

            @if (!hideRepeatUntil) {
                <lib-checkbox
                    [formControl]="form.controls.RepeatIndefinitely"
                    i18n="@@RepeatIndefinitely"
                    [qaTag]="qaTag ? qaTag + '-repeat-indefinitely-checkbox' : ''"
                    (change)="RepeatIndefinitelyChanged()">
                    Repeat indefinitely
                </lib-checkbox>
            }

            @if (!form.controls.RepeatIndefinitely.value) {
                <lib-input-date
                    [formControl]="form.controls.EndDate"
                    [minDate]="minDate"
                    [layout]="FormFieldLayout.Half"
                    [qaTag]="qaTag ? qaTag + '-repeat-until-input' : ''"
                    (change)="Changed()">
                    <ng-container
                        label
                        i18n="@@LibraryFormFieldFrequencyPickerRepeatUntil">
                        Repeat Until
                    </ng-container>
                </lib-input-date>
            }
        }
    </form>
    @if (dateWarning) {
        <div
            #warningBanner
            class="pt-4">
            <lib-banner
                [kind]="StatusKind.Danger"
                [mode]="BannerMode.Inline"
                [isDismissable]="false">
                <ng-container
                    text
                    i18n="@@TPMileageWarningBannerDeletingEntriesAfterDate">
                    You will be deleting any entry after {{ dateWarning }}
                </ng-container>
            </lib-banner>
        </div>
    } @else if (showHoldExpiry) {
        <div class="pt-4">
            <lib-banner
                [kind]="StatusKind.Warning"
                [mode]="BannerMode.Inline"
                [isDismissable]="false">
                <!-- prettier-ignore -->
                <ng-container
                    text
                    i18n="@@TPCalendarHoldPastDateBannerWarning">
                    The date selected is in the past and surpasses the <b>Weekly Time Slot Hold Duration</b>. Therefore, the hold will not be created.
                </ng-container>
            </lib-banner>
        </div>
    }
</lib-form-field-container>

<ng-template #myLabel>
    <ng-content
        label
        select="[label]"></ng-content>
</ng-template>
